//system
import { Injectable } from '@angular/core';
import { HttpService, HttpServiceConfig } from './common/http.service';

//services
import { LogService } from './common/log.service';

//models
import { Card, PaymentIntentResponse, PaymentMethod, PaymentRequest } from 'src/app/models/common-models';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { SetupIntentResponse } from '../models/io';

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  
  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  getCustomerCards(memberId: number): Promise<Card[]> {
    return this.httpService.getPromise<Card[]>(`Stripe/Cards/${memberId}`);
  }

  getCustomerPaymentMethods(memberId: number): Promise<PaymentMethod[]> {
    return this.httpService.getPromise<PaymentMethod[]>(`Stripe/PaymentMethods/${memberId}`);
  }

  addCard(memberId: number, token: string, makeDefault: boolean): Observable<boolean | string> {
    return this.httpService.post<boolean>(`Stripe/AddCard/${memberId}/${token}/${makeDefault}`, null, new HttpHeaders(), true);
  }

  setPaymentMethodDefault(memberId: number, paymentMethodId: string): Observable<boolean> {
    return this.httpService.put<boolean>(`Stripe/SetAsDefaultPaymentMethod/${memberId}/${paymentMethodId}`, null);
  }

  removeCard(memberId: number, cardId: string): Observable<boolean> {
    return this.httpService.delete<boolean>(`Stripe/DeleteCard/${memberId}/${cardId}`, null);
  }

  createPaymentIntent(paymentRequest: PaymentRequest): Observable<PaymentIntentResponse> {
    return this.httpService.post<PaymentIntentResponse>(`Stripe/CreatePaymentIntent`, paymentRequest);
  }

  getPaymentIntent(paymentIntentId: string): Promise<any> {
    return this.httpService.getPromise<any>(`Stripe/PaymentIntent/${paymentIntentId}`);
  }

  updatePaymentIntent(paymentIntentId: string, amount: number, paymentMethod?: string): Observable<void> {
    return this.httpService.put<void>(`Stripe/PaymentIntent/${paymentIntentId}`, { "Amount" : amount, "PaymentMethod": paymentMethod || '' });
  }

  createSetupIntent(memberId: number): Observable<SetupIntentResponse> {
    return this.httpService.post<SetupIntentResponse>(`Stripe/CreateSetupIntent/${memberId}`, null);
  }

  verifyBankAccount(paymentMethodId: string, verificationCode: string): Observable<boolean> {
    return this.httpService.post<boolean>(`Stripe/VerifyBankAccount`, {
      PaymentMethodId: paymentMethodId,
      VerificationCode: verificationCode,
    });
  }

  trackSetupIntent(setupIntentId: string, paymentMethodId: string, memberId?: number): Observable<boolean> {
    return this.httpService.post<boolean>(`Stripe/TrackSetupIntent`, {
      MemberId: memberId,
      SetupIntentId: setupIntentId,
      PaymentMethodId: paymentMethodId,
    });
  }
}